import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
export const useSupportRequestsStore = defineStore('supportRequests', {
  id: 'supportRequestPublic',
  state: () => ({
    items: [],
    supportRequestScreenshotBlob: null,
    api: '/api/v1/support-requests'
  }),
  getters: {
    supportRequestScreenshotBlobGet(state) {
      return state.supportRequestScreenshotBlob
    },
    ...getters
  },
  actions: {
    supportRequestScreenshotBlobSet (supportRequestScreenshotBlob) {
      this.supportRequestScreenshotBlob = supportRequestScreenshotBlob
    },
    ...actions,
  }
})
